import mixpanel from 'mixpanel-browser';

const mixpanelToken = import.meta.env.VITE_MIXPANEL_SECRET;
mixpanel.init(mixpanelToken);

const env = import.meta.env.VITE_REACT_APP_MIXPANEL_ENV === 'production';

const actions = {
  identify: (id: string) => {
    if (env) mixpanel.identify(id);
  },
  alias: (id: string) => {
    if (env) mixpanel.alias(id);
  },
  track: (name: string, props = {}) => {
    if (env) {
      mixpanel.track(name, props);
    }
  },
  people: {
    set: (props: any) => {
      if (env) mixpanel.people.set(props);
    },
  },
};

const mixpanelSvc = actions;

export default mixpanelSvc;
